import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IAuthorization } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import { AuthorizationsApiClient } from '../../apiClient/authorizations'
import axios from '../../apiClient/axios'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface IAuthorizationsAction extends IDefaultAction {
  payload?: IAuthorization[],
}

export interface IAuthorizationsState extends IDefaultState {
  payload?: IAuthorization[],
}

const initState: IAuthorizationsState = {}

export const authorizationsStateLoadFromApi = createAsyncThunk(
  'AuthorizationsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IAuthorization>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<IAuthorization>> = await new AuthorizationsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const authorizationsSlice = createSlice({
  name: 'authorizationsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(authorizationsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(authorizationsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(authorizationsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearAuthorizations } = authorizationsSlice.actions
export default authorizationsSlice.reducer